import S from "@babel/runtime/helpers/esm/objectSpread2";
import z from "@babel/runtime/helpers/esm/slicedToArray";
import A from "@babel/runtime/helpers/esm/toConsumableArray";
import I from "@babel/runtime/helpers/esm/objectWithoutProperties";
import ee from "@babel/runtime/helpers/esm/classCallCheck";
import re from "@babel/runtime/helpers/esm/createClass";
import b from "@babel/runtime/helpers/esm/assertThisInitialized";
import te from "@babel/runtime/helpers/esm/inherits";
import oe from "@babel/runtime/helpers/esm/createSuper";
import d from "@babel/runtime/helpers/esm/defineProperty";
import $ from "@babel/runtime/helpers/esm/typeof";
import { sstyled as ne } from "@semcore/utils/lib/core/index";
import ie, { Component as ae, assignProps as j, sstyled as se } from "@semcore/core";
import i from "react";
import U from "@semcore/utils/lib/canUseDOM";
import { Box as ue } from "@semcore/flex-box";
import pe from "@semcore/outside-click";
import ce, { PortalProvider as le } from "@semcore/portal";
import fe from "@semcore/neighbor-location";
import { setRef as V, forkRef as de } from "@semcore/utils/lib/ref";
import { isFocusInside as ge, setFocus as me, makeFocusLockSyntheticEvent as ve, useFocusLock as he } from "@semcore/utils/lib/use/useFocusLock";
import { callAllEventHandlers as O } from "@semcore/utils/lib/assignProps";
import _e from "@semcore/utils/lib/pick";
import be from "@semcore/utils/lib/uniqueID";
import { animationContext as ye, Scale as Pe } from "@semcore/animation";
import { cssVariableEnhance as Re } from "@semcore/utils/lib/useCssVariable";
import { useContextTheme as Fe } from "@semcore/utils/lib/ThemeProvider";
import Ce, { useFocusSource as Ee } from "@semcore/utils/lib/enhances/keyboardFocusEnhance";
import { hasParent as T } from "@semcore/utils/lib/hasParent";
import ke from "@semcore/utils/lib/logger";
import Te from "./createPopper.mjs";
import { useZIndexStacking as Se, ZIndexStackingContextProvider as xe } from "@semcore/utils/lib/zIndexStacking";
var De = ["placement", "modifiers", "strategy", "onFirstUpdate"], we = ["onKeyDown"], Me = ["onKeyDown"], Ae = (
  /*__reshadow_css_start__*/
  (ne.insert(
    /*__inner_css_start__*/
    '.___SPopper_y1qip_gg_{outline:0;color:var(--intergalactic-text-primary, #191b23)}.___SPopper_y1qip_gg_.__keyboardFocused_y1qip_gg_:focus:after{position:absolute;display:block;content:"";top:0;right:0;bottom:0;left:0;box-shadow:var(--intergalactic-keyboard-focus, 0px 0px 0px 3px rgba(0, 143, 248, 0.5));pointer-events:none;border-radius:var(--intergalactic-popper-rounded, 6px)}.___SPopper_y1qip_gg_.__keyboardFocused_y1qip_gg_.__hideFocus_y1qip_gg_:focus:after{box-shadow:none}.___SFocusHint_y1qip_gg_{display:none}.___STrigger_y1qip_gg_:focus .___SFocusHint_y1qip_gg_,.___STrigger_y1qip_gg_:focus-within .___SFocusHint_y1qip_gg_{display:inline}',
    "y1qip_gg_"
  ), {
    __SPopper: "___SPopper_y1qip_gg_",
    _keyboardFocused: "__keyboardFocused_y1qip_gg_",
    _hideFocus: "__hideFocus_y1qip_gg_",
    __SFocusHint: "___SFocusHint_y1qip_gg_",
    __STrigger: "___STrigger_y1qip_gg_"
  })
);
function Ie(o) {
  return $(o) === "object" && !Array.isArray(o);
}
function Oe(o, g) {
  return o.filter(function(l) {
    return g.indexOf(l) !== -1;
  });
}
var $e = function(g) {
  var l = i.useRef(-1), v = i.useCallback(function(e) {
    var r;
    e < Date.now() || ((r = g.current) === null || r === void 0 || r.update(), l.current = requestAnimationFrame(function() {
      return v(e);
    }));
  }, []);
  return i.useEffect(function() {
    return function() {
      return cancelAnimationFrame(l.current);
    };
  }, []), v;
}, vr = function(g) {
  var l;
  return typeof g == "string" ? g.toLowerCase().includes("input") : $(g) === "object" && g !== null && typeof g.displayName == "string" ? g.displayName.toLowerCase().includes("input") : $(g) === "object" && g !== null && typeof ((l = g.render) === null || l === void 0 ? void 0 : l.displayName) == "string" ? g.render.displayName.toLowerCase().includes("input") : !1;
}, W = !1, B = 0, N = ["offset", "preventOverflow", "arrow", "flip", "computeStyles", "eventListeners"], x = /* @__PURE__ */ function(o) {
  te(l, o);
  var g = oe(l);
  function l(v) {
    var e;
    return ee(this, l), e = g.call(this, v), d(b(e), "eventsInteractionMap", {
      click: {
        trigger: [["onClick"], ["onClick"]],
        popper: []
      },
      hover: {
        trigger: [["onMouseEnter", "onKeyboardFocus", "onTouchStart"], ["onMouseLeave", "onBlur"]],
        popper: [["onMouseEnter", "onFocusCapture", "onTouchStart"], ["onMouseLeave"]]
      },
      focus: {
        trigger: [["onFocus", "onClick"], ["onBlur"]],
        // to intercept faster than onBlur on the trigger
        popper: [["onFocusCapture"], ["onBlur"]]
      },
      none: {
        trigger: [],
        popper: []
      }
    }), d(b(e), "triggerRef", /* @__PURE__ */ i.createRef()), d(b(e), "popperRef", /* @__PURE__ */ i.createRef()), d(b(e), "popper", /* @__PURE__ */ i.createRef()), d(b(e), "lastPopperReference", null), d(b(e), "ignoreTriggerFocus", !1), d(b(e), "mouseEnterCursorPositionRef", {
      current: null
    }), d(b(e), "createTriggerRef", function(r) {
      r && e.triggerRef.current !== r && (V(e.triggerRef, r), e.createPopper());
    }), d(b(e), "createPopperRef", function(r) {
      r && e.popperRef.current !== r && (V(e.popperRef, r), e.createPopper());
    }), d(b(e), "getPopperOptions", function() {
      var r = e.asProps, t = r.placement, n = r.modifiers, a = r.strategy, s = r.onFirstUpdate, u = I(r, De), p = _e(u, N), _ = [];
      typeof p.offset == "number" && (p.offset = [0, p.offset]);
      var h = N.filter(function(c) {
        return p[c] !== void 0;
      }).map(function(c) {
        return {
          name: c,
          options: Ie(p[c]) ? p[c] : d({}, c, p[c])
        };
      });
      h.push({
        name: "computeStyles",
        options: {
          gpuAcceleration: !1
        }
      }), e.asProps.cursorAnchoring && h.push({
        name: "cursorAnchoring",
        options: {
          cursorAnchoring: e.asProps.cursorAnchoring,
          mouseEnterCursorPositionRef: e.mouseEnterCursorPositionRef
        }
      }), e.asProps.popperMargin && h.push({
        name: "applyMaxSize",
        enabled: !0,
        options: {
          margin: e.asProps.popperMargin,
          popperCtx: b(e)
        }
      });
      var y = [].concat(_, A(h)).concat(n);
      return {
        placement: t,
        strategy: a,
        onFirstUpdate: O(s, function() {
          var c, m, R;
          if ((c = e.observer) === null || c === void 0 || c.observe(e.triggerRef.current), (m = e.observer) === null || m === void 0 || m.observe(e.popperRef.current), !e.asProps.disablePortal)
            for (var C = (R = e.popperRef.current) === null || R === void 0 ? void 0 : R.parentElement, D = 10, E = 0; E < D; E++) {
              var F;
              if (!C || ((F = e.observer) === null || F === void 0 || F.observe(C), C === document.body)) break;
              C = C.parentElement;
            }
        }),
        modifiers: y
      };
    }), d(b(e), "makeKeyDownHandler", function(r) {
      return function(t) {
        var n = e.asProps.visible;
        n && t.key === "Escape" && (t.stopPropagation(), e.bindHandlerChangeVisibleWithTimer(!1, r, "onKeyDown")(t));
      };
    }), d(b(e), "bindHandlerKeyDown", function(r, t) {
      return O(r, e.makeKeyDownHandler(t));
    }), d(b(e), "lastPopperClick", 0), d(b(e), "bindHandlerChangeVisibleWithTimer", function(r, t, n) {
      return function(a) {
        var s = e.triggerRef.current;
        if (t === "trigger" && n === "onBlur") {
          var u = a.relatedTarget, p = a.target;
          if (u && p && T(u, s) && T(p, s))
            return;
        }
        if (t === "trigger" && n === "onClick") {
          var _ = T(a.target, s), h = A((s == null ? void 0 : s.labels) || []), y = h.some(function(R) {
            return T(e.popperRef.current, R);
          });
          if (_ && y && Date.now() - e.lastPopperClick < 100)
            return;
        }
        if (!(t === "popper" && n === "onMouseEnter" && Date.now() - B > 100)) {
          n === "onMouseEnter" && (e.mouseEnterCursorPositionRef.current = {
            x: a.clientX,
            y: a.clientY
          });
          var c = ["onFocus", "onKeyboardFocus", "onFocusCapture"].includes(n);
          if (!(e.ignoreTriggerFocus && r && t === "trigger" && c)) {
            r || setTimeout(function() {
              var R = e.popperRef.current;
              (R == null ? void 0 : R.getAttribute("tabindex")) === "0" && R.setAttribute("tabindex", "-1");
            }, 0);
            var m = a == null ? void 0 : a.currentTarget;
            t === "trigger" && m && m instanceof HTMLElement && (e.lastPopperReference = m), e.handlerChangeVisibleWithTimer(r, a, function() {
              clearTimeout(e.timerMultiTrigger), e.timerMultiTrigger = setTimeout(function() {
                r && t === "trigger" && e.popper.current && e.lastPopperReference && e.popper.current.state.elements.reference !== e.lastPopperReference && (e.popper.current.state.elements.reference = e.lastPopperReference, e.popper.current.setOptions({})), !r && t === "popper" && setTimeout(function() {
                  e.ignoreTriggerFocus = !1;
                }, 0);
              }, 0);
            }), t === "popper" && !r && ["onClick", "onBlur", "onKeyDown"].includes(n) && (e.ignoreTriggerFocus = !0);
          }
        }
      };
    }), d(b(e), "handlerChangeVisibleWithTimer", function(r, t, n) {
      var a = e.asProps, s = a.timeout, u = a.disabled;
      if (!(typeof u == "boolean" && u && r)) {
        var p = e.handlers, _ = typeof s == "number" ? [s, s] : s, h = r ? _[0] : _[1];
        clearTimeout(e.timer), e.timer = setTimeout(function() {
          p.visible(r, t);
        }, h), n();
      }
    }), d(b(e), "handlePopperFocusOut", function(r) {
      e.asProps.focusLoop || T(r.target, e.triggerRef.current) || e.bindHandlerChangeVisibleWithTimer(!1, "popper", "onBlur")(r);
    }), d(b(e), "handlePopperClick", function() {
      e.lastPopperClick = Date.now();
    }), U() && (e.observer = new ResizeObserver(function() {
      requestAnimationFrame(function() {
        var r;
        (r = e.popper.current) === null || r === void 0 || r.update();
      });
    })), e;
  }
  return re(l, [{
    key: "uncontrolledProps",
    value: function() {
      return {
        visible: null
      };
    }
  }, {
    key: "createPopper",
    value: function() {
      var e;
      if (!(!this.triggerRef.current || !this.popperRef.current) && !this.asProps.__disablePopper) {
        var r = !!(!((e = this.lastPopperReference) === null || e === void 0) && e.parentElement);
        this.popper.current = Te(r ? this.lastPopperReference : this.triggerRef.current, this.popperRef.current, this.getPopperOptions());
      }
    }
  }, {
    key: "componentDidMount",
    value: function() {
      U() && !W && (W = !0, document.addEventListener("mousemove", function() {
        B = Date.now();
      }, {
        capture: !0
      }));
    }
  }, {
    key: "componentDidUpdate",
    value: function(e) {
      var r = this, t = ["strategy", "placement", "offset", "preventOverflow", "arrow", "flip", "computeStyles", "eventListeners", "onFirstUpdate", "cursorAnchoring"];
      this.popper.current && t.some(function(n) {
        return e[n] !== r.asProps[n];
      }) && this.popper.current.setOptions(this.getPopperOptions());
    }
  }, {
    key: "destroyPopper",
    value: function() {
      var e;
      clearTimeout(this.timer), clearTimeout(this.timerMultiTrigger), (e = this.observer) === null || e === void 0 || e.disconnect(), this.popper.current && (this.popper.current.destroy(), this.popper.current = null);
    }
  }, {
    key: "handlersFromInteraction",
    value: function(e, r, t) {
      var n = this, a = typeof e == "string" ? this.eventsInteractionMap[e] : e, s = z(a[r], 2), u = s[0], p = u === void 0 ? [] : u, _ = s[1], h = _ === void 0 ? [] : _, y = Oe(p, h), c = {};
      return p.forEach(function(m) {
        c[m] = n.bindHandlerChangeVisibleWithTimer(!0, r, m);
      }), h.forEach(function(m) {
        c[m] = n.bindHandlerChangeVisibleWithTimer(!1, r, m);
      }), y.forEach(function(m) {
        c[m] = t ? n.bindHandlerChangeVisibleWithTimer(!1, r, m) : n.bindHandlerChangeVisibleWithTimer(!0, r, m);
      }), c;
    }
  }, {
    key: "getTriggerProps",
    value: function() {
      var e = this.asProps, r = e.visible, t = e.interaction, n = e.disableEnforceFocus, a = e.explicitTriggerSet, s = this.handlersFromInteraction(t, "trigger", r), u = s.onKeyDown, p = I(s, we);
      return S(S({
        ref: a ? void 0 : this.createTriggerRef,
        active: r,
        interaction: t
      }, p), {}, {
        onKeyDown: this.bindHandlerKeyDown(u, "trigger"),
        disableEnforceFocus: n,
        popperRef: this.popperRef
      });
    }
  }, {
    key: "getPopperProps",
    value: function() {
      var e = this.asProps, r = e.visible, t = e.disablePortal, n = e.interaction, a = e.placement, s = e.duration, u = e.animationsDisabled, p = e.disableEnforceFocus, _ = this.handlersFromInteraction(n, "popper", r), h = _.onKeyDown, y = I(_, Me);
      return S(S({
        ref: this.createPopperRef,
        triggerRef: this.triggerRef,
        visible: r,
        interaction: n,
        disablePortal: t
      }, y), {}, {
        onKeyDown: this.bindHandlerKeyDown(h, "popper"),
        placement: a,
        duration: s,
        animationsDisabled: u,
        popper: this.popper,
        disableEnforceFocus: p,
        handleFocusOut: this.handlePopperFocusOut,
        onClick: this.handlePopperClick
      });
    }
  }, {
    key: "setContext",
    value: function() {
      return {
        popper: this.popper,
        setTrigger: this.createTriggerRef,
        setPopper: this.createPopperRef
      };
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.destroyPopper();
    }
  }, {
    key: "render",
    value: function() {
      var e = this.asProps, r = e.Children, t = e.visible, n = e.root, a = e.onOutsideClick, s = e.excludeRefs;
      return /* @__PURE__ */ i.createElement(i.Fragment, null, t ? /* @__PURE__ */ i.createElement(pe, {
        root: n,
        excludeRefs: [this.triggerRef, this.popperRef].concat(A(s)),
        onOutsideClick: O(a, this.bindHandlerChangeVisibleWithTimer(!1))
      }) : null, /* @__PURE__ */ i.createElement(r, null));
    }
  }]), l;
}(ae);
d(x, "displayName", "Popper");
d(x, "style", Ae);
d(x, "defaultProps", {
  defaultVisible: !1,
  placement: "auto",
  modifiers: [],
  arrow: {
    padding: 6
  },
  strategy: "absolute",
  interaction: "click",
  timeout: 0,
  excludeRefs: [],
  focusLoop: !0,
  cursorAnchoring: !1
});
d(x, "enhance", [be(), Re({
  variable: "--intergalactic-duration-popper",
  fallback: "200",
  map: Number.parseInt,
  prop: "duration"
})]);
function Le(o) {
  var g = arguments[0], l = ue, v = o.Children, e = o.focusHint, r = o.onKeyboardFocus, t = o.highlighted, n = o.active, a = o.popperRef, s = o.forwardRef, u = i.useRef();
  i.useEffect(function() {
    t === !0 && r({
      currentTarget: u.current
    });
  }, [t]);
  var p = Ee(), _ = i.useCallback(function(y) {
    p.current === "keyboard" && T(y.target, u.current) && (r == null || r());
  }, [r, p.current, u.current]);
  i.useEffect(function() {
    var y;
    return (y = u.current) === null || y === void 0 || y.addEventListener("focusin", _), function() {
      var c;
      (c = u.current) === null || c === void 0 || c.removeEventListener("focusin", _);
    };
  }, [u.current, _]);
  var h = i.useRef(n);
  return h.current = n, i.useEffect(function() {
    if (n && a.current)
      return function() {
        setTimeout(function() {
          h.current || !ge(a.current) && document.activeElement !== document.body || p.current === "keyboard" && me(u.current);
        }, 1);
      };
  }, [n]), /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement(l, j({
    inline: !0,
    "aria-haspopup": !0,
    ref: de(u, s),
    onBlur: o.onBlur
  }, g), /* @__PURE__ */ i.createElement(v, null)), e && !1);
}
function L(o) {
  var g = arguments[0], l, v = Pe, e = o.Children, r = o.styles, t = o.visible, n = o.disablePortal, a = o.ignorePortalsStacking, s = o.disableEnforceFocus, u = o.triggerRef, p = o.autoFocus, _ = o.controlsLength, h = o.duration, y = o.animationsDisabled, c = o.popper, m = o.focusMaster, R = m === void 0 ? !1 : m, C = o.handleFocusOut, D = o.role, E = o.zIndex, F = i.useRef(null), Z = Se("z-index-popper"), f = i.useCallback(function(P) {
    P.stopPropagation();
  }, []), H = i.useCallback(function(P) {
    var k;
    P.nativeEvent.stopImmediatePropagation(), (k = F.current) === null || k === void 0 || k.dispatchEvent(ve(P));
  }, []), X = i.useState(n), K = z(X, 2), Y = K[0], G = K[1];
  he(F, p, u, !t || s || !Y, R, C), Fe(F, t);
  var q = $e(c), J = i.useCallback(function(P) {
    P > 0 && q(Date.now() + Math.min(P, 2e3));
  }, [q]), Q = i.useCallback(function() {
    var P;
    (P = c.current) === null || P === void 0 || P.update();
  }, []), w = i.useContext(ye);
  return i.useEffect(function() {
    if (a && w) {
      var P = w.onAnimationStart(J), k = w.onAnimationEnd(Q);
      return function() {
        P(), k();
      };
    }
  }, [w, a]), i.useEffect(function() {
    if (D === "dialog" && t && process.env.NODE_ENV !== "production") {
      var P = function(M) {
        return !!(M.hasAttribute("aria-label") || M.hasAttribute("aria-labelledby") || M.hasAttribute("title"));
      };
      ke.warn(F.current && !P(F.current), "'title' or 'aria-label' or 'aria-labelledby' are required props for popper with role dialog", o["data-ui-name"] || L.displayName);
    }
  }, [t, D]), l = se(r), /* @__PURE__ */ i.createElement(ce, l.cn("Portal", {
    disablePortal: n,
    ignorePortalsStacking: a,
    onMount: G
  }), /* @__PURE__ */ i.createElement(fe, l.cn("NeighborLocation", {
    controlsLength: _
  }), /* @__PURE__ */ i.createElement(xe, l.cn("ZIndexStackingContextProvider", {
    designToken: "z-index-popper"
  }), /* @__PURE__ */ i.createElement(v, l.cn("SPopper", S({}, j({
    animationsDisabled: y,
    visible: t,
    duration: [h, h / 2],
    ref: F,
    onClick: f,
    onContextMenu: f,
    onDoubleClick: f,
    onDrag: f,
    onDragEnd: f,
    onDragEnter: f,
    onDragExit: f,
    onDragLeave: f,
    onDragOver: f,
    onDragStart: f,
    onDrop: f,
    onMouseDown: f,
    onMouseMove: f,
    onMouseOver: f,
    onMouseOut: f,
    onMouseUp: f,
    onKeyDown: H,
    onKeyPress: f,
    onKeyUp: f,
    onFocus: f,
    onBlur: H,
    onChange: f,
    onInput: f,
    onInvalid: f,
    onReset: f,
    onSubmit: f,
    "use:zIndex": E ?? Z
  }, g))), /* @__PURE__ */ i.createElement(le, l.cn("PortalProvider", {
    value: F
  }), /* @__PURE__ */ i.createElement(e, l.cn("Children", {})))))));
}
L.enhance = [Ce(!1)];
var hr = ie(x, {
  Trigger: Le,
  Popper: L
});
export {
  hr as default,
  vr as isInputTriggerTag
};
